export default __webpack_public_path__ + "static/media/img_declaration_title.788d00ca.svg";